import { SSO_ACTIONS } from '../../actions/ssoActions';

const ssoReducer = (state = {
  isAuthenticatedUsingSSO: false
},action) => {
  switch(action.type) {
    case SSO_ACTIONS.SSO: {
      state = {
        ...state,
        isAuthenticatedUsingSSO: true
      }
      break;
    }
    case SSO_ACTIONS.RESET_SSO: {
      state = {
        ...state,
        isAuthenticatedUsingSSO: false
      }
      break;
    }
    default : {
      break;
    }
  }
  return state;
}

export default ssoReducer;
